import styled from 'styled-components';

export const Isin = styled.div`
  color: var(--color-disabled);
  line-height: 24px;
`;
